import React from "react";
import { Carousel as BootstrapCarousel } from "react-bootstrap";

class Carousel extends React.Component {
  render() {

    const items = [
      {
        // image: "/city.jpg",
        image: "/gallery/23.jpg",
        label: "First slide label",
        description: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
      },
      {
        // image: "/desk.jpeg",
        image: "/gallery/30.jpg",
        label: "Second slide label",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      },
      {
        // image: "/rave.jpeg",
        image: "/gallery/31.jpg",
        label: "Third slide label",
        description: "Praesent commodo cursus magna, vel scelerisque nisl consectetur.",
      }
    ]

    const imageStyles = {
      maxHeight: "500px",
    }

    const carouselItems = items.map((item, index) => {
      return (
        <BootstrapCarousel.Item key={index}>
          <img width={1000} height={600} alt="900x500" src={item.image} className="img-responsive center-block" style={imageStyles}/>
          {/* <BootstrapCarousel.Caption>
            <h3>{item.label}</h3>
            <p>{item.description}</p>
          </BootstrapCarousel.Caption> */}
        </BootstrapCarousel.Item>
      );
    })

    return (
      <BootstrapCarousel>
        {carouselItems}
      </BootstrapCarousel>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.js